// store/modules/navigation.js

const state = () => ({
  tempNavigationData: {}
})

const getters = {
  tempNavigationData: state => state.tempNavigationData
}

const mutations = {
  setTempNavigationData (state, data) {
    state.tempNavigationData = data
  },
  clearTempNavigationData (state) {
    state.tempNavigationData = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
